import { createMuiTheme } from '@material-ui/core/styles'
// Use createMuiTheme here is good for theme object key suggestion

const theme = createMuiTheme({
  palette: {
    type: 'dark',
  },
})

export default theme
